import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import { type FormFieldComponentProps } from "@/lib/types/types";

interface PassedProps {
  explanation?: string | JSX.Element;
  required?: boolean;
}
export const PostalCodeComponent = ({
  value,
  isErrored,
  onChange,
  explanation,
  required = true, // backwards compatibility. TODOv2 make this the same as other fields
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps & PassedProps) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("postalCode")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="postal-code"
      refId="postalCode"
      pattern="[a-zA-Z0-9 ]*"
      value={value}
      onChange={onChange}
      placeholder={placeholder || msg({ id: "postalCodePlaceholder" })}
      label={<FormattedHTMLMessage id="postalCode" defaultMessage="Postal Code" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidPostalCode"
            defaultMessage="Invalid postal code"
          />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      required={required}
      explanation={explanation && explanation}
      disabled={disabled}
      autoComplete="postal-code"
    />
  );
};
